import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useSummaryModel } from "./summaryModel";
import useGlobalModel from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData,
    } = useSummaryModel();

    const { getSelectedDict, appDs } = useGlobalModel();

    const onSearch = (val = {}) => {
        loadData({ pageNum: 1 }, { ...searchParam, ...val })
    }

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "客户名称",
            fieldName: "name",
            size: "small",
            disabled: false
        },
        // {
        //     type: SearchTypeEnum.TreeSelect,
        //     span: 4,
        //     placeholder: "组织机构",
        //     fieldName: "orgCode",
        //     size: "small",
        //     treeDs: orgDs,
        //     disabled: false
        // },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "客户类型",
            fieldName: "categoryCode",
            size: "small",
            disabled: false,
            options: getSelectedDict(DictCodeEnmu.CUSTOMER_TYPE)
            // options: [{ label: "正常", value: "0" }, { label: "非正常", value: "9" }]
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "系统分支",
            fieldName: "branch",
            size: "small",
            options: appDs,
        },
    ]

    return (
        <YhPageHeader
            title="客户账户"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            triggerSearch
            onChange={updateSearchParam} 
            handleSearch={onSearch}
            handleReset={resetSearchParam}
        />
    );
}